import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'

export const Container = styled(Grid, {
  name: 'Container',
  slot: 'Root',
  skipSx: true,
})`
  font-family: 'Source Sans Pro';
  font-size: 14px;
`
